module.exports = __webpack_public_path__ + "img/icon3.fdc32dd5.svg";